import { render } from "./MeetingsWrapper.vue?vue&type=template&id=65101636&scoped=true"
import script from "./MeetingsWrapper.vue?vue&type=script&lang=js"
export * from "./MeetingsWrapper.vue?vue&type=script&lang=js"

import "./MeetingsWrapper.vue?vue&type=style&index=0&id=65101636&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65101636"]])

export default __exports__